const opacities = {
  backdropOpacity: 0.4,
};

export { opacities as default };
